@if (field()) {
  <button
    class="iot-platform-ui-filter-engine-filter-menu"
    [ngClass]="{ 'iot-platform-ui-filter-engine-filter-menu--opened': menuOpened() }"
    [disabled]="false"
    [matMenuTriggerFor]="menu"
    mat-button
  >
    <mat-icon class="iot-platform-ui-filter-engine-filter-menu__icon-type">
      @if (ofTypeList()) {
        format_list_bulleted
      } @else {
        text_fields
      }
    </mat-icon>

    {{ $safeNavigationMigration(field()?.fullLabel) | translate }}

    <mat-icon iconPositionEnd class="iot-platform-ui-filter-engine__icon-type">
      @if (menuOpened()) {
        arrow_drop_up
      } @else {
        arrow_drop_down
      }
    </mat-icon>
  </button>
  <mat-menu
    #menu="matMenu"
    [hasBackdrop]="closeOnClickOutside()"
    yPosition="below"
    xPosition="after"
    class="iot-platform-ui-filter-engine-filter-menu__menu iot-platform-ui-filter-engine-filter-menu__menu--{{ field()?.fieldType }}"
  >
    <div class="iot-platform-ui-filter-engine-filter-menu__field-container ag-theme-material" (click)="$event.stopPropagation()">
      <div class="iot-platform-ui-filter-engine-filter-menu__field" fxFlex>
        <div
          class="iot-platform-ui-filter-engine-filter-menu-field-text"
          data-cy="iot-platform-ui-filter-engine-filter-menu-field-text"
          fxLayout="column"
          fxLayoutGap="12px"
          fxLayoutAlign="start center"
        >
          <!-- Dynamic Field Component -->
          <ng-container #fieldContainer />

          <div class="iot-platform-ui-filter-engine-filter-menu__field-actions" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end center">
            <button
              class="iot-platform-ui-filter-engine-filter-menu__field-reset-button"
              mat-stroked-button
              (click)="onReset()"
              [disabled]="!canReset()"
              type="button"
              [matTooltip]="'AG_GRID.resetFilter' | translate"
            >
              {{ 'AG_GRID.resetFilter' | translate }}
            </button>

            @if (!(ofTypeList() && requiresValue()) || !isAutoApply()) {
              <button
                class="iot-platform-ui-filter-engine-filter-menu__field-apply-button"
                mat-raised-button
                color="accent"
                (click)="onApply()"
                [disabled]="!canApply()"
                type="button"
                [matTooltip]="'AG_GRID.applyFilter' | translate"
              >
                {{ 'AG_GRID.applyFilter' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </mat-menu>
}
